import {
  GET_ORGANIZATION,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATION_FAIL,
} from "./actionTypes"


export const getOrganization = () => ({
  type: GET_ORGANIZATION,
})

export const getOrganizationSuccess = organization => ({
  type: GET_ORGANIZATIONS_SUCCESS,
  payload: organization,
})

export const getOrganizationFail = error => ({
  type: GET_ORGANIZATION_FAIL,
  payload: error,
})
